
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Menu from "@/components/store/menu.vue";

@Component({ components: { Menu } })
export default class Store extends Vue {

}
